export const backflowSizeOptions = [
  { label: 'Select size', value: '' },
  { label: '1/2 inch', value: '0.5' },
  { label: '3/4 inch', value: '0.75' },
  { label: '1 inch', value: '1' },
  { label: '1.5 inch', value: '1.5' },
  { label: '2 inch', value: '2' },
  { label: '3 inch', value: '3' },
  { label: '4 inch', value: '4' },
  { label: '6 inch', value: '6' },
  { label: '8 inch', value: '8' },
  { label: '10 inch', value: '10' },
  { label: '12 inch', value: '12' },
];

export const yesNoOptions = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const passFailOptions = [
  { label: 'Pass', value: 'pass' },
  { label: 'Fail', value: 'fail' },
];
